/**
 * Staff Proxy Entry Banner — HIGH #8
 *
 * When URL has ?proxy=staff, shows a banner collecting staff info.
 * Stores proxy data in sessionStorage for submission audit trail.
 */

import React, { useState, useEffect } from 'react';

const ProxyModeBanner = () => {
  const [isProxy, setIsProxy] = useState(false);
  const [staffName, setStaffName] = useState('');
  const [staffRole, setStaffRole] = useState('');
  const [confirmed, setConfirmed] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('proxy') === 'staff') {
      setIsProxy(true);
      // Check if already confirmed in this session
      const stored = sessionStorage.getItem('proxy_staff_info');
      if (stored) {
        const data = JSON.parse(stored);
        setStaffName(data.name);
        setStaffRole(data.role);
        setConfirmed(true);
      }
    }
  }, []);

  const handleConfirm = () => {
    if (!staffName.trim() || !staffRole) return;
    const proxyData = {
      mode: 'proxy',
      name: staffName.trim(),
      role: staffRole,
      timestamp: new Date().toISOString(),
    };
    sessionStorage.setItem('proxy_staff_info', JSON.stringify(proxyData));
    setConfirmed(true);
  };

  if (!isProxy) return null;

  return (
    <div
      role="banner"
      aria-label="Staff proxy entry mode"
      style={{
        background: '#fef3c7',
        border: '1px solid #fbbf24',
        borderRadius: '8px',
        padding: '12px 16px',
        margin: '0 auto 12px',
        maxWidth: '800px',
        fontSize: '13px',
      }}
    >
      {confirmed ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#92400e" strokeWidth="2">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
          </svg>
          <span style={{ color: '#92400e' }}>
            <strong>Staff proxy mode:</strong> Data entered by {staffRole} {staffName}
          </span>
        </div>
      ) : (
        <div>
          <p style={{ fontWeight: 600, color: '#92400e', margin: '0 0 8px' }}>
            You are entering data on behalf of a patient. Please identify yourself:
          </p>
          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
            <input
              type="text"
              value={staffName}
              onChange={(e) => setStaffName(e.target.value)}
              placeholder="Your name"
              aria-label="Staff member name"
              style={{ padding: '6px 10px', borderRadius: '4px', border: '1px solid #d1d5db', fontSize: '13px', flex: '1', minWidth: '120px' }}
            />
            <select
              value={staffRole}
              onChange={(e) => setStaffRole(e.target.value)}
              aria-label="Staff role"
              style={{ padding: '6px 10px', borderRadius: '4px', border: '1px solid #d1d5db', fontSize: '13px' }}
            >
              <option value="">Select role</option>
              <option value="RN">RN (Registered Nurse)</option>
              <option value="MA">MA (Medical Assistant)</option>
              <option value="Physician">Physician</option>
              <option value="Admin">Front Desk / Admin</option>
            </select>
            <button
              type="button"
              onClick={handleConfirm}
              disabled={!staffName.trim() || !staffRole}
              style={{
                padding: '6px 16px', background: '#92400e', color: '#fff',
                border: 'none', borderRadius: '4px', fontSize: '13px',
                cursor: staffName.trim() && staffRole ? 'pointer' : 'not-allowed',
                opacity: staffName.trim() && staffRole ? 1 : 0.5,
                fontFamily: 'inherit',
              }}
            >
              Confirm
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProxyModeBanner;
